// extracted by mini-css-extract-plugin
export default {"primaryBlue":"#00a2d2","primaryLightGrey":"#d1d1d1","subheading":"Subheading_subheading__ky9Nl","small":"Subheading_small__zqbzT","medium":"Subheading_medium__FiLPv"};